'use strict';
import React from 'react';

import { get, isEmpty } from 'lodash';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import ReservationOption from './ReservationOption';
import { connect } from 'react-redux';
import { APPOINTMENTS } from '../../../data/reducer';
import Alert from '../../Alert';
import { selectClinic } from '../../../data/appointment/actions';
import { selectShowAppointmentPagePlaceholder } from '../../../data/appointment/selector';
import { validatePinCode } from '../../../data/appointment/actions';

let { id: module_id } = module;

class ReservableAppointments extends React.Component {
  selectOption = (key) => {
    let { history, selectClinic } = this.props;
    selectClinic(key);
    history.push('/appointments/new');
  };

  render() {
    let {
      data,
      error,
      showPlaceholder,
      validatePinCode,
      pinCodeIsValid,
      pinCodeError,
      appointmentError,
    } = this.props;

    if (showPlaceholder) {
      return null;
    }

    let other = null;

    if (error) {
      other = <Alert message={`${module_id}.${error.code}`} />;
    } else if (isEmpty(data)) {
      other = (
        <p>
          <FormattedMessage id={`${module_id}.no.reservable.appointments`} />
        </p>
      );
    }

    return (
      <div>
        {other || (
          <ul className="appointment-container">
            {data &&
              data.map((reservationOption) => (
                <ReservationOption
                  key={reservationOption.key}
                  data={reservationOption}
                  pinCodeIsValid={pinCodeIsValid}
                  pinCodeError={pinCodeError}
                  selectOption={this.selectOption}
                  validatePinCode={validatePinCode}
                  appointmentError={appointmentError}
                />
              ))}
          </ul>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let { isFetching, data, error, pinCodeIsValid, pinCodeError } =
    state[APPOINTMENTS].reservation.clinics;
  let appointmentError = state[APPOINTMENTS].appointments.error;
  return {
    isFetching,
    data,
    error,
    showPlaceholder: selectShowAppointmentPagePlaceholder(state),
    pinCodeIsValid,
    pinCodeError,
    appointmentError,
  };
};

export default withRouter(
  connect(mapStateToProps, { selectClinic, validatePinCode })(
    ReservableAppointments
  )
);
